import type { ArchiMateElement, RelationshipType } from './types';

const STRUCTURAL_RELATIONSHIPS: RelationshipType[] = ['composition', 'aggregation'];

export function getElementBounds(element: ArchiMateElement) {
  const width = element.width ?? 120;
  const height = element.height ?? 60;

  return {
    width,
    height,
    left: element.x - width / 2,
    right: element.x + width / 2,
    top: element.y - height / 2,
    bottom: element.y + height / 2,
  };
}

export function elementContains(
  container: ArchiMateElement,
  candidate: ArchiMateElement,
  padding = 8
): boolean {
  const parentBounds = getElementBounds(container);
  const childBounds = getElementBounds(candidate);

  return (
    childBounds.left >= parentBounds.left + padding &&
    childBounds.right <= parentBounds.right - padding &&
    childBounds.top >= parentBounds.top + padding &&
    childBounds.bottom <= parentBounds.bottom - padding
  );
}

export function isStructuralRelationship(type: RelationshipType): boolean {
  return STRUCTURAL_RELATIONSHIPS.includes(type);
}
